import { Tooltip } from "@mui/material";
import { type ReactElement, type ReactNode, memo } from "react";

import { TAB_STATUSES } from "@/constants";
import { useUrlParams } from "@/hooks";

interface MenuTooltipProps {
  children?: ReactNode;
  text?: string;
  isMobile?: boolean;
  section?: "accordion-title" | "accordion-item" | "asset-menu";
}

const styles = {
  tooltip: {
    color: "#000",
    backgroundColor: "#fff",
    fontFamily: "Open Sans",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px",
  },
  arrow: {
    backgroundColor: "#fff",
  },
};

function MenuTooltip(props: MenuTooltipProps) {
  const { children, text, isMobile, section } = props;
  const { tabStatus } = useUrlParams();
  const placement = isMobile ? "bottom" : "right";

  const leftPadding = section === "accordion-item" ? 24 : 0;

  let lengthToShow = 17;
  if (section !== "asset-menu" && tabStatus === TAB_STATUSES.CUSTOMIZE) {
    // customize has buttons to rename and hide, and that covers the name a bit
    lengthToShow = 5;
  }

  return (
    <Tooltip
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            ...styles.tooltip,
            ...(placement === "right" && leftPadding && { left: leftPadding }),
          },
        },
        arrow: {
          sx: {
            "&::before": styles.arrow,
          },
        },
      }}
      title={String(text).length > lengthToShow ? text : ""}
      placement={placement}
      arrow
    >
      {children as ReactElement}
    </Tooltip>
  );
}

export default memo(MenuTooltip);
